
export const USER_DONOR = 1;
export const USER_DONATION_RECIPIENT = 2;
export const USER_SUBSCRIPTION_RECIPIENT = 3;
export const USER_PURCHASE_RECIPIENT = 4;

export const VISITOR_DONATION = 1;
export const VISITOR_SUBSCRIPTION = 3;
export const VISITOR_PURCHASE = 4;